(function () {
  var MQ = window.matchMedia('(max-width: 700px)');

  function initBenefitCards(root) {
    if (!root || root.dataset.benefitCardsInitialized === 'true') return;

    var cards = Array.from(root.querySelectorAll('[data-benefit-card]'));
    var N = cards.length;
    if (N < 2) return;

    root.dataset.benefitCardsInitialized = 'true';

    var BASE_TOP = 0;
    var TOP_STEP = 6;
    var SCALE_PER_DEPTH = 0.04;
    var TRANSITION_PX = 360;

    var stickyTops = cards.map(function (_, i) { return BASE_TOP + i * TOP_STEP; });
    cards.forEach(function (card, i) {
      card.style.top = stickyTops[i] + 'px';
      card.style.zIndex = i + 1;
    });

    var cardDocTops = [];
    function cachePositions() {
      var sy = window.scrollY;
      cardDocTops = cards.map(function (card) {
        return card.getBoundingClientRect().top + sy;
      });
    }

    function update() {
      var scrollY = window.scrollY;
      cards.forEach(function (card, i) {
        var depth = 0;
        for (var j = i + 1; j < N; j++) {
          var threshold = cardDocTops[j] - stickyTops[j];
          if (scrollY > threshold) {
            depth += Math.min((scrollY - threshold) / TRANSITION_PX, 1);
          }
        }
        var scale = Math.max(1 - (N - 1) * SCALE_PER_DEPTH,
          1.0 - depth * SCALE_PER_DEPTH);
        card.style.transform = 'perspective(1200px) scale(' + scale.toFixed(4) + ')';
      });
    }

    var ticking = false;
    function onScroll() {
      if (!ticking) {
        requestAnimationFrame(function () { update(); ticking = false; });
        ticking = true;
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });

    requestAnimationFrame(function () {
      cachePositions();
      update();
    });

    root.benefitCardsCleanup = function () {
      window.removeEventListener('scroll', onScroll);
    };
  }

  function cleanupBenefitCards(root) {
    if (!root) return;
    if (root.benefitCardsCleanup) {
      root.benefitCardsCleanup();
      root.benefitCardsCleanup = null;
    }
    root.querySelectorAll('[data-benefit-card]').forEach(function (card) {
      card.style.transform = '';
      card.style.top = '';
      card.style.zIndex = '';
    });
    root.dataset.benefitCardsInitialized = 'false';
  }

  function initAll(context) {
    (context || document).querySelectorAll('[data-benefit-cards]').forEach(function (root) {
      if (!root._benefitCardsMqListener) {
        root._benefitCardsMqListener = function (e) {
          if (e.matches) {
            initBenefitCards(root);
          } else {
            cleanupBenefitCards(root);
          }
        };
        MQ.addEventListener('change', root._benefitCardsMqListener);
      }
      if (MQ.matches) {
        initBenefitCards(root);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var root = event.target && event.target.querySelector
      ? event.target.querySelector('[data-benefit-cards]')
      : null;
    if (root) {
      if (root._benefitCardsMqListener) {
        MQ.removeEventListener('change', root._benefitCardsMqListener);
        root._benefitCardsMqListener = null;
      }
      cleanupBenefitCards(root);
    }
  });
})();
